import { STATES_MAP } from '@repo/supergraph/marketplace/constants';
import type { StateAbbreviation } from '@repo/supergraph/marketplace/types';
import { isValidState } from '@repo/supergraph/utils/geo-data';
import cookies from 'js-cookie';

const REGION_CODE_COOKIE_NAME = 'X-Cf-Request-RegionCode';

export const STATE_OPTIONS = Object.entries(STATES_MAP).map(([abbreviation, name]) => ({
  label: name,
  value: abbreviation,
}));

export const DEFAULT_STATE_OPTION = 'CA';

export function getSafeRegionCodeFromClientCookies(): StateAbbreviation | undefined {
  const value = cookies.get(REGION_CODE_COOKIE_NAME) ?? '';
  return isValidState(value) ? value : undefined;
}

export function getSafeRegionCode(state?: string): StateAbbreviation {
  const regionCode = state ?? DEFAULT_STATE_OPTION;
  return isValidState(regionCode) ? regionCode : DEFAULT_STATE_OPTION;
}
